import React from 'react';
import PackageManagement from '../../components/admin/business/PackageManagement';

const BusinessManagementPage = () => {
  return (
    <div className="p-6">
      {/* <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Business Package Management</h1>
        <p className="text-gray-600">Manage your business packages and pricing</p>
      </div> */}
      <PackageManagement />
    </div>
  );
};

export default BusinessManagementPage;